import React from 'react'
import { lifecycle } from 'recompose'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Table from '../../../table/component/Table'
import getColumnList from './partner-column-list'
import {
    LANGUAGE_FAMILY_PREFIXES,
    SUPPORTED_LANGUAGES,
} from '../../../internationalization/languageConstants'
import { COUNTRY_CODE_LIST } from '../../../internationalization/const'
import TableColumnSelector from "../../../table/component/TableColumnSelector"
import Row from "../../../bootstrap/component/Row";
import Column from "../../../bootstrap/component/Column";
import {Link} from "react-router-dom";

const PartnerSearch = ({
    tableData,
    changeFilter,
    toggleSort,
    toggleMultiSort,
    gotoPage,
    navigateToPartner,
    toggleColumnVisibility,
}) => {
    const columnList = getColumnList()

    return (
        <ContentBox title="Partners - Store / Clinics">

            <Row bottom='S'>
                <Column size={1}>
                    <Link to={'/partner/add/'} class='btn btn-primary'>Add Partner</Link>
                </Column>
            </Row>

            <TableColumnSelector
                resultsNumber={tableData.objectList.length}
                hiddenColumns={tableData.hiddenColumns}
                columnList={columnList}
                toggleColumnVisibility={toggleColumnVisibility}
            />

            <Table
                {...tableData}
                filterSetting={
                    {
                        language: languageSimplifierFilterSetting,
                        countryCode: {
                            type: 'select',
                            valueList: COUNTRY_CODE_LIST,
                        },
                    }
                }
                changeFilter={changeFilter}
                toggleSort={toggleSort}
                toggleMultiSort={toggleMultiSort}
                gotoPage={gotoPage}
                idProperty="id"
                columnList={columnList}
                onRowClick={partner => {
                    navigateToPartner(partner.id)
                }}
            />
        </ContentBox>
    )
}

PartnerSearch.propTypes = {
    tableData: PropTypes.object.isRequired,
    navigateToPartner: PropTypes.func.isRequired,
    changeFilter: PropTypes.func,
    toggleSort: PropTypes.func,
    toggleMultiSort: PropTypes.func,
    gotoPage: PropTypes.func,
}

/*
 * Filtering happens on the server, so we need to feed in server-stored values
 * To achieve filtering by locale string snippets, we need a `select` type table filter,
 *  where we display language families (English) and do filtering by the corresponding locale snippet
 */
const languageSimplifierFilterSetting = {
    type: 'select',
    valueList: SUPPORTED_LANGUAGES.map(lang => ({
        id: LANGUAGE_FAMILY_PREFIXES[lang],
        value: lang,
    })),
}
export default withLayout(lifecycle({
    componentDidMount () {
        this.props.initialTableSettings()
        this.props.initialTableQuery()
    },
})(PartnerSearch))



// WEBPACK FOOTER //
// ./src/modules/partner/component/search/PartnerSearch.js